import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--padding-3);
	background-color: var(--white);
	width: 100%;
	border-radius: 4px;
	padding: 0 var(--padding-2) var(--padding-1);
	> div > div > span.typography {
		width: -webkit-fill-available;
		pointer-events: none;
	}
`;
export const AccordionHeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	@media ${Breakpoints.mobile} {
		align-items: flex-start;
	}

	> div.mobile {
		flex: 1;
		display: grid;
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 2fr);
		grid-gap: 1rem;
		align-items: flex-start;

		@media ${Breakpoints.mobile} {
			grid-template-columns: 1fr 1fr;
		}
	}
`;
export const AccordionContentContainer = styled.div`
	display: grid;
	grid-template-columns: 1.5fr 1fr 1fr;
	grid-gap: 1rem;
	align-items: flex-start;

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const ResultColumns = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 1rem;
	margin: 1rem;
	width: 100%;
`;
